import { render } from "./mega-nav.vue?vue&type=template&id=588f53c4"
import script from "./mega-nav.vue?vue&type=script&lang=js"
export * from "./mega-nav.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/derek-lam-1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__